import Cookies from 'js-cookie'

const SESSION_TIMEOUT_MINUTES = 30
const SESSION_TIMEOUT_DAYS = SESSION_TIMEOUT_MINUTES / (24 * 60)

export class CookieHelper {
  static get(key: string): any {
    return Cookies.get(key)
  }

  static set(key: string, data: any, options: any = {}): any {
    return Cookies.set(key, data, options)
  }

  static remove(key: string): any {
    return Cookies.remove(key)
  }

  static setAzureADMeToken(token: string | null): any {
    const cookie = JSON.stringify({ token, auth_type: "azure_ad" })
    return this.set("me", cookie, { expires: SESSION_TIMEOUT_DAYS })
  }

  static refreshAzureADMe(): any {
    const me = this.get("me")
    if (!me) {
      return
    }

    try {
      const data = JSON.parse(me)
      if (data?.auth_type !== "azure_ad") {
        return
      }
    } catch (error) {
      return
    }

    return this.set("me", me, { expires: SESSION_TIMEOUT_DAYS })
  }

  static getBool(key: string): boolean {
    return this.get(key) === 'true'
  }
}
